import React, { Suspense } from 'react';

import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';

import Layout from './hoc/Layout/Layout';

import SearchVarieties from './container/SearchVarieties/SearchVarieties';

import './App.scss';
import VarietyDataSheet from './components/UI/VarietyDataSheet/VarietyDataSheet';
import { getToken, NO_COOKIE_ERROR, checkTokenError, getCookieToken, logoutAndDeleteStorage, APP_URLS } from './shared/utility';
import SearchSpecies from './container/SearchSpecies/SearchSpecies';
import SearchClasses from './container/SearchClasses/SearchClasses';
import Registers from './container/Registers/Registers';
import TestDenomination from './container/TestDenomination/TestDenomination';
import ErrorPage from './container/ErrorPage/ErrorPage';
import TestDataSheet from './components/TestDataSheet/TestDataSheet';
import MyTests from './container/MyTests/MyTests';
import MyAlerts from './container/MyAlerts/MyAlerts';
import Statistics from './container/Statistics/Statistics'
import RequestAPIAccess from './container/RequestAPIAccess/RequestAPIAccess';
import { AlertServiceProvider } from './shared/AlertService';
//import Cookies from 'js-cookie';
import { useIdleTimer } from 'react-idle-timer';
import Contributions from './container/Contributions/Contributions';
import Jurisprudence from './container/Jurisprudence/Jurisprudence';

const checkLoggedIn = (token: string) => {
  if (token && !checkTokenError(token)) {
    return true;
  } else {
    return false;
  }
}

function App() {

  React.useEffect(() => {
    const cookieValue = getCookieToken();
    if (cookieValue) {
      // sessionStorage.clear()
      // localStorage.clear()
      sessionStorage.removeItem(process.env.REACT_APP_COOKIE_KEY!);
      sessionStorage.setItem(process.env.REACT_APP_COOKIE_KEY!, cookieValue)
      // Cookies.remove(process.env.REACT_APP_COOKIE_KEY!, { domain: '.plantvarieties.eu', path: '/' })
    }

    setInitialized(true);
  }, []);

  const [initialized, setInitialized] = React.useState(false);

  const token = getToken();
  const isLoggedIn: boolean = checkLoggedIn(token);

  const routes = isLoggedIn ? (
    <Switch>
      <Route path={`${APP_URLS.SEARCH_VARIETIES}/:countryid-:publicationextraid-:publicationtype-:varietyid`} component={() => <VarietyDataSheet show={true} standAlone={true}/>} />
      <Route path="/mytests/:testid" component={() => <TestDataSheet show={true} standAlone={true}/>} />
      <Route path="/timeout" component={() => <ErrorPage title="timeout_error" subtitle="session_expired"/>} />
      <Layout>
          <Route exact path="/"
                render={() => {
                    return (
                      <Redirect to={APP_URLS.SEARCH_VARIETIES} />
                    )
                }}
              />
          <Route path={APP_URLS.SEARCH_VARIETIES} exact component={() => <SearchVarieties />} />
          <Route path="/species" exact component={() => <SearchSpecies />} />
          <Route path="/classes" exact component={() => <SearchClasses />} />
          <Route path="/registers" exact component={() => <Registers />} />
          <Route path="/denominations" exact component={() => <TestDenomination />} />
          <Route path="/myalerts" exact component={() => <MyAlerts />} />
          <Route path="/mytests" exact component={() => <MyTests />} />
          <Route path="/statistics" exact component={() => <Statistics />} />
          <Route path="/contributions" exact component={() => <Contributions />} />
          <Route path="/jurisprudence" exact component={() => <Jurisprudence />} />
          <Route path="/requestAPIAccess" exact component={() => <RequestAPIAccess />} />
      </Layout>
    </Switch>
  ) : (
    <Switch>
      <Route path={`${APP_URLS.SEARCH_VARIETIES}/:countryid-:publicationextraid-:publicationtype-:varietyid`} component={() => <VarietyDataSheet show={true} standAlone={true}/>} />
      <Route path="/timeout" component={() => <ErrorPage title="timeout_error" subtitle="session_expired"/>} />
      <Route path="/error" component={() => <ErrorPage title="application_error" subtitle="internal_server_error"/>} />
      {token === NO_COOKIE_ERROR?
        <Redirect to="/error" />
        :
        <>
          <Route path='/' component={() => {
                window.location.replace(process.env.REACT_APP_LOGIN_URL!);
                return null;
            }}/>
          <Redirect to="/" />
        </>
      }
    </Switch>
  );

  const history = useHistory();
  const location = useLocation();

  const handleOnIdle = (event: any) => {
    if (location.pathname.startsWith(`${APP_URLS.SEARCH_VARIETIES}/`) && location.pathname.length > 13) {
      return;
    }
    logoutAndDeleteStorage(false);
    history.push('/timeout')
  }

  useIdleTimer({
    timeout: 1000 * parseInt(process.env.REACT_APP_IDLE_TIME_INTERVAL!),
    onIdle: handleOnIdle,
    debounce: 500
  });

  return (
    <Suspense fallback={<p>Loading...</p>}>
      <AlertServiceProvider>
        {initialized?routes:<p>Loading...</p>}
      </AlertServiceProvider>
    </Suspense>
  );
}

export default App;
